export interface IMaskable {
	getMaskedValue: () => string;
}

export function isMaskable(value: unknown): value is IMaskable {
	return value instanceof Object && 'getMaskedValue' in value && typeof value.getMaskedValue === 'function';
}
